import { useTranslation } from 'react-i18next';

import { paths } from 'src/routes/paths';
import { CONFIG } from 'src/config-global';
import { useJsonLd } from 'src/hooks/use-json-ld';
import { Reveal } from 'src/components/reveal';
import { PageSeo } from 'src/components/page-seo';
import { PageHero } from 'src/components/page-hero';
import { useLocales } from 'src/locales/use-locales';

import { ContactForm } from './contact-form';

export function ContactView() {
  const { t } = useTranslation('contact');
  const { t: tCommon } = useTranslation('common');
  const { currentLang } = useLocales();

  const items = t('aside.items', { returnObjects: true });

  useJsonLd({
    '@type': 'ContactPage',
    name: t('hero.eyebrow'),
    '@context': 'https://schema.org',
    url: `${CONFIG.siteUrl}${paths.contact}`,
    inLanguage: currentLang.ogLocale.replace('_', '-'),
  });

  return (
    <>
      <PageSeo path={paths.contact} title={t('meta.title')} description={t('meta.description')} />

      <PageHero
        tightBottom
        lead={t('hero.lead')}
        title={t('hero.title')}
        eyebrow={t('hero.eyebrow')}
        current={t('hero.breadcrumb')}
        links={[{ to: paths.home, label: tCommon('labels.home') }]}
      />

      <div role="presentation" className="horizon" />

      <section className="section day loose-top">
        <div className="container">
          <div className="split">
            <ContactForm />
            <Reveal>
              <h2 className="split-title">{t('aside.title')}</h2>
              <div className="info-list">
                {items.map((item) => (
                  <div key={item.title} className="info-card">
                    <h3>{item.title}</h3>
                    <p>{item.text}</p>
                  </div>
                ))}
              </div>
            </Reveal>
          </div>
        </div>
      </section>
    </>
  );
}
